import { useCallback, useContext } from 'react';

import type { PasswordForgotten } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const usePasswordForgotten = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(async () => {
    return sendRequest<PasswordForgotten>('passwordForgotten', {});
  }, [sendRequest]);
};

export default usePasswordForgotten;
